"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldsInternshipDuration = void 0;
var OfferFieldsInternshipDuration_1 = require("./OfferFieldsInternshipDuration");
Object.defineProperty(exports, "OfferFieldsInternshipDuration", { enumerable: true, get: function () { return OfferFieldsInternshipDuration_1.OfferFieldsInternshipDuration; } });
